import { render, staticRenderFns } from "./PageProdutos.vue?vue&type=template&id=a2d0550c&scoped=true&"
import script from "./PageProdutos.vue?vue&type=script&lang=js&"
export * from "./PageProdutos.vue?vue&type=script&lang=js&"
import style0 from "./PageProdutos.vue?vue&type=style&index=0&id=a2d0550c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2d0550c",
  null
  
)

export default component.exports